import gql from 'graphql-tag'
import { EnumFields } from '@/graphql/fragments'

export const ServiceFragment = gql`
  fragment Service on settings_service{
    ${EnumFields}
  }
`
